import React, { createContext, useContext, useState, useEffect } from 'react';
import { _getEmp } from 'services/login.service';
import { Box, CircularProgress } from '@material-ui/core';

const AccessContext = createContext();

let accessGranted = true; // TODO: trocar para false quando funcionalidade for totalmente implementada

export const AccessProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const token = sessionStorage.getItem("@Emissor/Token");
  const cnpj = sessionStorage.getItem("@Emissor/cnpj");

  const getCertificateData = (empresa) => {
    if (!empresa) return;

    const diasParaVencerCertificado = Number.parseInt(empresa.dias_vencimento_certificado?.split("+")[0]);

    let modalAtualizarCertificado = false;

    if (diasParaVencerCertificado <= 7) {
      modalAtualizarCertificado = true;
    }

    sessionStorage.setItem("@Emissor/modalAtualizarCertificado", modalAtualizarCertificado);
    sessionStorage.setItem("@Emissor/diasVencimentoCertificado", diasParaVencerCertificado);
    sessionStorage.setItem("@Emissor/razaoSocial", empresa.razao_social);

    return {
      modalAtualizarCertificado,
      dias_vencimento: diasParaVencerCertificado,
      razao_social: empresa.razao_social,
    }
  }

  const updateAccess = (empresa, mensalidadeVencida) => {
    if (empresa) {
      // TODO: Corrigir typo no backend para "mensalidadeVencida"
      console.log("Empresa:", empresa);
      accessGranted = !(empresa?.acesso?.mesalidadeVencida);
      return;
    }

    accessGranted = !mensalidadeVencida;
  };

  const isGrantedAccess = () => {
    return accessGranted;
  };

  useEffect(() => {
    const flag = false; // TODO: remover quando funcionalidade for totalmente implementada
    if (token && cnpj && flag) {
      // Revalida a empresa com o backend usando os dados guardados de forma segura
      const headers = { headers: { "Authorization": "Bearer " + token } };
      _getEmp(cnpj, headers)
        .then(response => {
          const empresa = response.data[0];
          updateAccess(empresa);
        })
        .catch(err => {
          console.error("Erro ao validar empresa no refresh", err);
          accessGranted = false;
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  // Segura a tela até o backend responder se o acesso é válido
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh" width="100vw">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <AccessContext.Provider value={{ updateAccess, getCertificateData, isGrantedAccess }}>
      {children}
    </AccessContext.Provider>
  );
};

export const useAccess = () => {
  const context = useContext(AccessContext);
  if (!context) {
    throw new Error('useAccess must be used within AccessProvider');
  }
  return context;
};
